<a class="brand-name" [routerLink]="nav_path.home" rel="noreferrer">{{company.name}}</a>
<img class="brand-logo" src="assets/imgs/logo.webp" [routerLink]="nav_path.home" [alt]="company.name+' Logo'" />

<router-outlet></router-outlet>
